import { BACKEND_DOMAIN } from "utils/constants";
import { buildRequestHeaders } from "utils/helpers";

async function mutationUpdateCustomerAccountFn(accessToken: string, customerAccountUid: string, customerAccount: CustomerAccount) {
    const URL = `${BACKEND_DOMAIN}/customer_accounts/${customerAccountUid}/update`

    const response = await fetch(URL, {
                method: "POST",
                headers: buildRequestHeaders(accessToken),
                body: JSON.stringify(customerAccount),
    })
    if (!response.ok) {
        throw new Error('Failed to update customer account');
    }    
    return response.json();
    
}

export default mutationUpdateCustomerAccountFn;
